import { AgentControllerService } from "@/api";
import type { EstateAgentDetail } from "@/api/temp/AgentEstateService";
import type { RequestOptions } from "@/hooks/usePaginateQuery";

/**
 * Agent details from the generated client, typed as the UI's model. A
 * shorthand method: its name is the mock and query key, which the production
 * minifier keeps.
 */
export const AgentDetailsApi = {
  async getEstateAgentUsingGet(
    params: { agentId: string },
    options?: RequestOptions,
  ) {
    const agent = (await AgentControllerService.getEstateAgentUsingGet(
      params,
      options,
    )) as unknown as EstateAgentDetail | undefined;
    // The API may leave these arrays out; the UI iterates them.
    return (
      agent && {
        ...agent,
        mcpServices: (agent.mcpServices ?? []).map(service => ({
          ...service,
          capabilities: service.capabilities ?? [],
          tools: service.tools ?? [],
        })),
      }
    );
  },
};
